<template>
	<div class="popup" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">{{group ? 'Изменить' : 'Добавить'}} группу магазинов</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="add-store">
					<div class="add-store__input">
						<InputText :label="'Наименование группы магазинов'" :placeholder="'Введите наименование группы магазинов'" v-model="formData.name" :errors="v$.formData.name.$errors"/>
					</div>
					<hr>
					<div class="add-store__label page-label">Магазины</div>

					<div class="add-store__filters">
						<InputSearch actionBtn :label="'Поиск магазина'" :inputGray="true" v-model="filter.query"/>
					</div>
					<div class="add-store__view">
						<ListStores v-model="formData.shops" :group="group" :filter="filter"/>
					</div>
				</div>
			</div>
			<hr>

			<div class="popup__btns">
				<button class="btn btn--color" @click.prevent="sendForm">{{group ? 'Сохранить' : 'Добавить'}}</button>
			</div>
		</div>
	</div>
</template>
<script>
import InputText from "@/components/base/utils/formElements/InputText.vue";
import InputSearch from "@/components/base/utils/formElements/InputSearch.vue";
import ListStores from "@/components/sections/Store/ListStores.vue";
import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";
import useVuelidate from "@vuelidate/core";
import {required, helpers} from '@vuelidate/validators'
import { useToast } from "vue-toastification";

const {withMessage} = helpers

export default {
	name: 'AddEditStorePopup',
	components: {
		InputText,
		InputSearch,
		ListStores,
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	props: {
		group: {
			type: Object,
			default: () => {}
		},
		change: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			toast: useToast(),
			formData: {
				name:  '' || this.group?.name,
				shops: [],
				id: '' || this.group?.id
			},
			searchQuery: '',
			cities: ['Екатеринбург', 'Челябинск', 'Москва', 'Уфа'],
			citiesSelected: '',
			filter: {
				query: '',
				cities: ''
			}
		}
	},
	methods: {
		async sendForm() {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				this.toast.error('Пожалуйста, заполните все поля');
				return
			}

			const body = objectToFormData({
				name: this.formData.name,
				shops: this.formData.shops,
				id: this.formData.id
			})

			let response = await Fetch('shop-groups/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success(`Группа успешно ${this.change ? 'изменена' : 'добавлена'}`);
				this.$emit('refreshList')
				this.$emit('close')

			} else {
				this.toast.error(response.message);
			}
		},
	},
	validations() {
		return {
			formData: {
				name: {
					required: withMessage("Заполните наименование", required),
				},
			}
		}
	},
}
</script>
